import HelpersType from 'cookieBanner/helpers'
type GetCookieGDPRFlags = {
  shouldShowCookieBanner: boolean
  isCookieBannerAvailable: boolean
  isAnalyticalCookieEnabled: boolean
}

declare global {
  interface Window {
    cookieGDPRHelpers: typeof HelpersType
  }
}

// we should use window for avoiding the problem with tracking.
// in some external packages we can't get helpers from MFE
const getHelpers = async (): Promise<typeof HelpersType> => {
  if (window.cookieGDPRHelpers) {
    return window.cookieGDPRHelpers
  }

  try {
    const { default: helpers } = await import('cookieBanner/helpers')
    window.cookieGDPRHelpers = helpers
  } catch (err) {
    await new Promise(resolve => setTimeout(resolve, 500))
    return getHelpers()
  }

  return window.cookieGDPRHelpers
}

export const getCookieGDPRFlags = async (): Promise<GetCookieGDPRFlags> => {
  const helpers = await getHelpers()
  const isCookieBannerAvailable = helpers.checkIfCookieBannerAvailable()

  return {
    isCookieBannerAvailable,
    shouldShowCookieBanner:
      isCookieBannerAvailable && helpers.checkIfShouldShow(),
    isAnalyticalCookieEnabled:
      !isCookieBannerAvailable || helpers.checkIfAnalyticalCookieEnabled()
  }
}
